import type {
    AuthService,
    UploadService,
    LeadTimeService,
    SupplierControlService,
    SupplierInsightsService,
    AsnMetricsService,
    AnalyticsService,
    MasterService,
} from './types';
import { awsAuthService } from './aws/awsAuthService';
import { awsUploadService } from './aws/awsUploadService';
import { awsLeadTimeService } from './aws/awsLeadTimeService';
import { awsSupplierControlService } from './aws/awsSupplierControlService';
import { awsSupplierInsightsService } from './aws/awsSupplierInsightsService';
import { awsAsnMetricsService } from './aws/awsAsnMetricsService';
import { awsAnalyticsService } from './aws/awsAnalyticsService';
import { awsMasterService } from './aws/awsMasterService';

/**
 * Resolves the active auth + upload implementation. Backed by real Cognito/S3
 * (via Amplify), configured from the runtime config loaded at startup.
 */
export function getAuthService(): AuthService {
    return awsAuthService;
}

export function getUploadService(): UploadService {
    return awsUploadService;
}

export function getLeadTimeService(): LeadTimeService {
    return awsLeadTimeService;
}

export function getSupplierControlService(): SupplierControlService {
    return awsSupplierControlService;
}

export function getSupplierInsightsService(): SupplierInsightsService {
    return awsSupplierInsightsService;
}

export function getAsnMetricsService(): AsnMetricsService {
    return awsAsnMetricsService;
}

export function getAnalyticsService(): AnalyticsService {
    return awsAnalyticsService;
}

export function getMasterService(): MasterService {
    return awsMasterService;
}
